import { cloneDeepWith, isString } from 'lodash';

const replaceVariables = (string: string, variables: Record<string, string>) => {
  return string.replace(/{{[^{}]*}}/g, substitution => {
    const variable = substitution.slice(2, substitution.length - 2);
    const value = variables[variable];

    if (!value) {
      console.error(new Error(`Failed to replace "${substitution}" substitution`));
    }

    return value ?? substitution;
  });
};

export const injectVariablesIntoPoll = <T>(poll: T, variables: Record<string, string>) => {
  return cloneDeepWith<T>(poll, value => {
    if (isString(value)) {
      return replaceVariables(value, variables);
    }

    return undefined;
  }) as T;
};
